import Alea from 'alea';
import { isElectronApp } from '../../config';

export enum Platform{
	'browser' = 1,
	'app' = 2,
}

export function getRandomInteger(min: number, max: number): number {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

// HERE RSA CAN BE USED TO INCREASE THE ACCURACY OF THE TEST
export const currentPlatform = () : Platform => {
	if ('api' in window) {
		return Platform.app;
	}
	return Platform.browser;
};

export const getConnectionStringFromNumber = (speedInMB: number): string => {
	if (speedInMB < 1) {
		return `${speedInMB * 1024} KB/s`;
	}
	return `${speedInMB} MB/s`;
};

export const generateOtp = (length: number) => {
	const digits = '0123456789';
	const len = digits.length;
	let OTP = '';
	OTP += Math.max(Math.floor(Math.random() * 10), 1);
	for (let index = 1; index < length; index += 1) {
		OTP += digits[Math.floor(Math.random() * len)];
	}
	return OTP;
};

export const generateRandomUUID = (prefix?: string, suffix?: string): string => `${prefix ? `${prefix}-` : ''}${crypto.randomUUID()}-${Date.now().toString(36)}${suffix ? `-${suffix}` : ''}`;

export function shuffleArray<T>(array: T[], ...seed: unknown[]): T[] {
	const randomNumber = Alea(seed);
	const arrayCopy = array.slice();
	let arraySize = arrayCopy.length;
	const shuffledArray = new Array<T>();
	while (arraySize > 0) {
		const index = Math.floor(randomNumber() * arraySize);
		const removedElement = arrayCopy.splice(index, 1)[0];
		shuffledArray.push(removedElement);
		// can swap instead for optimization
		arraySize = arrayCopy.length;
	}
	return shuffledArray;
}

export function generateCodeId(submission?: boolean): string {
	let codeId = `v1-${crypto.randomUUID()}-${generateOtp(6)}-${Date.now().toString(36)}`;
	if (submission) {
		codeId += '-submission';
	}
	return codeId;
}

export function checkIfPayloadNeedDecription(payload: unknown) {
	if (!payload || typeof payload !== 'object') {
		return false;
	}
	if ('headers' in payload && typeof payload.headers === 'object' && payload.headers) {
		const hasEncHeader = payload.headers['ENCRYPTION-VERSION'] ?? payload.headers['encryption-version'];
		return !!hasEncHeader;
	}
	return 'ciphertext' in payload;
}

const IDENTITY_CODE_PALETTE = Object.freeze([
	'#e03131',
	'#f76707',
	'#2f9e44',
	'#1971c2',
	'#7048e8',
	'#0c8599',
	'#c2255c',
	'#5c940d',
] as const);

export const getIdentityCodeCharColor = (
	char: string,
	position: number,
): string => IDENTITY_CODE_PALETTE[
	(char.charCodeAt(0) + position) % IDENTITY_CODE_PALETTE.length
];

export async function decodePayload(payload: Record<string, any>): Promise<Record<string, any>> {
	if (!isElectronApp || !('api' in window)) {
		return payload;
	}
	if (typeof window.api === 'object' && window.api && '_invoke' in window.api && typeof window.api._invoke === 'function') {
		return window.api._invoke('_decode-payload', payload);
	}
	return payload;
}
